import React, { type RefObject, useEffect } from "react";
import type { ScrollView } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { getTokenValue, updateTheme, View, YStack } from "tamagui";
import type { CustomerThemeOptions } from "../business/admin/customers/BusinessCustomerModel";
import { Header } from "./navigation/Header";
import { Title } from "./Title";

export const Screen = ({
  title,
  theme,
  children,
  noPadding,
  maxWidth,
}: {
  theme?: CustomerThemeOptions | null;
  title?: string;
  children?: React.ReactNode;
  noPadding?: boolean;
  scrollViewRef?: RefObject<ScrollView>;
  maxWidth?: number | "auto";
  skipStickyHeader?: boolean;
}) => {
  const insets = useSafeAreaInsets();

  const [shadowIntensity, setShadowIntensity] = React.useState(0.0);

  React.useEffect(() => {
    const handleScroll = () => {
      const y = Math.min(100, window.scrollY); // Get the vertical scroll position
      const intensity = y / 100;
      setShadowIntensity(Math.min(0.3, intensity)); // Limit the shadow intensity
    };

    // Attach the scroll event listener
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const maxWidthWindow = maxWidth ?? 600;

  useEffect(() => {
    updateTheme({
      name: "light",
      theme: {
        pressablePrimaryLabel:
          theme?.pressablePrimaryLabel ??
          getTokenValue("$pressablePrimaryLabel"),
        pressablePrimaryBackground:
          theme?.pressablePrimaryBackground ??
          getTokenValue("$pressablePrimaryBackground"),
      },
    });
  }, [theme]);

  return (
    <>
      <View
        maxWidth={maxWidthWindow}
        marginHorizontal={"auto"}
        width="100%"
        zIndex={30}
        style={{
          paddingTop: insets.top,
          position: "sticky",
          top: 0,
        }}
        shadowColor={"#000"}
        shadowOpacity={shadowIntensity}
        shadowRadius={12}
        shadowOffset={{ height: 0, width: 0 }}
      >
        <Header />
      </View>
      <YStack
        maxWidth={maxWidthWindow}
        marginHorizontal={"auto"}
        width="100%"
        gap="$medium"
        paddingVertical={noPadding ? 0 : "$space.medium"}
      >
        {!!title && (
          <View paddingHorizontal={"$space.large"}>
            <Title>{title}</Title>
          </View>
        )}
        {children}
      </YStack>
    </>
  );
};
